/**
 * FCM diagnostic logger — sends structured log entries to the backend and Rollbar.
 * Fire-and-forget; never throws.
 */

import { logNotificationEvent } from '@/api/notifications.api';
import { rollbar } from '@/lib/rollbar';
import type {
  NotificationLogLevel,
  NotificationLogPayload,
} from '@/types/notification.types';

const rollbarMethod: Record<
  NotificationLogLevel,
  'info' | 'warning' | 'error'
> = {
  info: 'info',
  warn: 'warning',
  error: 'error',
};

export function fcmLog(
  level: NotificationLogLevel,
  event: string,
  data?: NotificationLogPayload['data'],
): void {
  logNotificationEvent({
    level,
    event,
    source: 'main',
    data,
    ts: Date.now(),
    ua: navigator.userAgent,
  }).catch((_err) => {
    /* fire-and-forget */
  });

  rollbar[rollbarMethod[level]](`[FCM] ${event}`, {
    source: 'main',
    event,
    ...data,
  });
}

export const fcmInfo = (event: string, data?: NotificationLogPayload['data']) =>
  fcmLog('info', event, data);

export const fcmWarn = (event: string, data?: NotificationLogPayload['data']) =>
  fcmLog('warn', event, data);

export const fcmError = (
  event: string,
  data?: NotificationLogPayload['data'],
) => fcmLog('error', event, data);
